export default __webpack_public_path__ + "static/media/regulatory--no-motor-vehicles--g3.b3120ac6.png";